var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"setting"}},[_c('h2',[_vm._v("Setting")])])
}]

export { render, staticRenderFns }